<template>
  <section class="py-32 md:py-88 bg-gradient-to-b from-primary-10 to-white">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full md:w-10/12 lg:w-7/12">
          <h1 class="text-h-xl md:text-h-3xl font-bold text-center">
            {{ howItWorks.title }}
          </h1>
          <div
            v-if="howItWorks.body"
            class="text-center text-b-s md:text-b-xl font-medium text-neutral-80 pt-16"
            v-html="$sanitize(howItWorks.body)"
          />
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pt-32 md:pt-0">
      <div class="flex justify-center">
        <div class="w-full md:w-10/12 lg:w-7/12">
          <article v-for="(step, si) of howItWorks.steps" :key="si" class="flex pb-24 md:pb-40">
            <div
              class="h-28 md:h-36 w-28 md:w-36 min-w-28 md:min-w-36 rounded-full
            flex items-center justify-center text-h-m md:text-h-l bg-primary-100 text-white"
            >
              {{ si + 1 }}
            </div>
            <div class="pl-16 md:pl-32">
              <h3 class="text-h-l md:text-h-xl font-bold leading-28 md:leading-36 pb-16">
                {{ step.title }}
              </h3>
              <div class="text-h-m" v-html="$sanitize(step.description)" />
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
  <se-advisor-top-advisors-list>
    <template #header>
      <h2 class="text-h-xl md:text-h-2xl font-semibold pb-16 md:pb-32 md:text-center">
        {{ howItWorks.topAdvisors?.title || 'Check Our Top Advisors' }}
      </h2>
    </template>

    <template #footer>
      <div class="flex justify-center pt-16 md:pt-32">
        <Link href="/advisors/top?type=more" class="text-black no-underline">
          <se-button size="large" type="tertiary" class="hidden md:flex md:visible">
            {{ howItWorks.topAdvisors?.ctaText || 'Show All Top Advisors' }}<se-icon name="arrow-right" :size="20" class="ml-6" />
          </se-button>
          <se-button size="medium" type="tertiary" class="flex md:hidden ml-0">
            {{ howItWorks.topAdvisors?.ctaText || 'Show All Top Advisors' }}<se-icon name="arrow-right" :size="18" class="ml-6" />
          </se-button>
        </Link>
      </div>
    </template>
  </se-advisor-top-advisors-list>
</template>

<script lang="ts" setup>
import SeAdvisorTopAdvisorsList from '@/src/modules/advisor/components/top-advisors-list';
import { theme } from '@/theme';
import SeButton from '@/src/shared/ui-kit/button/Button';
import Link from '@/src/components/Link';
import SeIcon from '@/src/shared/ui-kit/icon/Icon';

const { howItWorks } = theme;
</script>

<script lang="ts">
export default {
  name: 'SeStaticHowItWorksPage',
};
</script>
